function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.53662 9.64307C6.52051 9.64307 7.43457 9.33203 8.18994 8.80518L10.9639 11.5854C11.1099 11.7251 11.3003 11.7949 11.5034 11.7949C11.9287 11.7949 12.2334 11.4712 12.2334 11.0522C12.2334 10.8555 12.1699 10.665 12.0239 10.519L9.26904 7.75781C9.84668 6.9834 10.1895 6.0249 10.1895 4.99023C10.1895 2.43213 8.09473 0.337402 5.53662 0.337402C2.97852 0.337402 0.883789 2.42578 0.883789 4.99023C0.883789 7.54834 2.97217 9.64307 5.53662 9.64307ZM5.53662 8.55762C3.5752 8.55762 1.96289 6.94531 1.96289 4.99023C1.96289 3.03516 3.5752 1.42285 5.53662 1.42285C7.4917 1.42285 9.104 3.03516 9.104 4.99023C9.104 6.94531 7.4917 8.55762 5.53662 8.55762Z",
  fill: "#788A9C"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9f37f915.svg";
export { ForwardRef as ReactComponent };